export default "__VITE_ASSET__437f093f__"